<template>
  <v-dialog v-model="valueLocal" max-width="480">
    <ng-sheet class="invoice-success-dialog">
      <h3 class="mb-3">Спасибо за заказ!</h3>
      <p>
        Мы&nbsp;пришлем счет на&nbsp;адрес
        <strong>{{ email }}</strong> в&nbsp;течение рабочего дня.
      </p>
      <ng-button
        icon
        icon-name="mdi-close"
        class="invoice-success-dialog__close"
        @click="valueLocal = false"
        text
      />
    </ng-sheet>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('order', ['email']),
    valueLocal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-success-dialog {
  position: relative;

  &__close {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
}
</style>
